// frontend/src/components/AppIcon.jsx
import React from "react";
import * as LucideIcons from "lucide-react";
import { HelpCircle } from "lucide-react";

// Import all icons used in LoadingSpinner and ErrorMessage
import {
  Loader2 as Loader,
  AlertTriangle,
  RefreshCw,
  WifiOff,
  Search,
  Lock,
  Home,
  ArrowLeft,
  Compass,
  LogIn,
  Grid3x3,
  List,
  AlertCircle,
  X,
  Check,
  Info,
  ChevronDown,
  ChevronUp,
  Filter,
  Star,
  Calendar,
  MapPin,
  Users,
  Mountain,
  Clock,
  DollarSign,
  TrendingUp,
  Cloud,
  Sun,
  Wind,
  Thermometer,
  Heart,
  Eye,
  EyeOff,
  Menu,
  X as XIcon,
  Plus,
  Minus,
  Trash2,
  Edit,
  Download,
  Upload,
  Share2,
  Bookmark,
  MessageCircle,
  Phone,
  Mail,
  Globe,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Linkedin,
} from "lucide-react";

// Create a combined icons object
const customIcons = {
  Loader,
  AlertTriangle,
  RefreshCw,
  WifiOff,
  Search,
  Lock,
  Home,
  ArrowLeft,
  Compass,
  LogIn,
  Grid3x3,
  List,
  AlertCircle,
  X: XIcon,
  Check,
  Info,
  ChevronDown,
  ChevronUp,
  Filter,
  Star,
  Calendar,
  MapPin,
  Users,
  Mountain,
  Clock,
  DollarSign,
  TrendingUp,
  Cloud,
  Sun,
  Wind,
  Thermometer,
  Heart,
  Eye,
  EyeOff,
  Menu,
  XIcon,
  Plus,
  Minus,
  Trash2,
  Edit,
  Download,
  Upload,
  Share2,
  Bookmark,
  MessageCircle,
  Phone,
  Mail,
  Globe,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Linkedin,
};

function Icon({
  name,
  size = 24,
  color = "currentColor",
  className = "",
  strokeWidth = 2,
  ...props
}) {
  // First check custom icons, then Lucide icons
  const IconComponent = customIcons[name] || LucideIcons?.[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return (
      <HelpCircle
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
}

// Export individual icons for direct usage
export {
  Loader,
  AlertTriangle,
  RefreshCw,
  WifiOff,
  Search,
  Lock,
  Home,
  ArrowLeft,
  Compass,
  LogIn,
  Grid3x3,
  List,
  AlertCircle,
  XIcon,
  Check,
  Info,
  ChevronDown,
  ChevronUp,
  Filter,
  Star,
  Calendar,
  MapPin,
  Users,
  Mountain,
  Clock,
  DollarSign,
  TrendingUp,
  Cloud,
  Sun,
  Wind,
  Thermometer,
  Heart,
  Eye,
  EyeOff,
  Menu,
  Plus,
  Minus,
  Trash2,
  Edit,
  Download,
  Upload,
  Share2,
  Bookmark,
  MessageCircle,
  Phone,
  Mail,
  Globe,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Linkedin,
};

export default Icon;
